var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42857 1.93004H14V8.68004L14.9643 9.64432H21.7143V11.5729H23.6429V7.33004L23.3536 6.63575L17.0279 0.271465L16.3529 0.00146484H1.46429L0.5 0.965751V26.0372L1.46429 27.0015H8.21429V25.0729H2.42857V1.93004ZM15.9286 1.93004L21.7143 7.71575H15.9286V1.93004ZM26.5357 13.5015H11.1071L10.1429 14.4658V26.0372L11.1071 27.0015H26.5357L27.5 26.0372V14.4658L26.5357 13.5015ZM25.5714 15.43V23.1443L22.4279 20.0586H21.0586L18.8214 22.315L14.7136 18.2072H13.3443L12.0714 19.48V15.43H25.5714ZM20.1714 23.665L21.7336 22.1029L24.7036 25.0729H21.5793L20.1714 23.665ZM12.0714 25.0729V22.1993L14 20.2708L18.86 25.0729H12.0714ZM22.6786 18.3229C22.9343 18.3229 23.1796 18.2213 23.3604 18.0405C23.5413 17.8596 23.6429 17.6144 23.6429 17.3586C23.6429 17.1029 23.5413 16.8576 23.3604 16.6768C23.1796 16.4959 22.9343 16.3943 22.6786 16.3943C22.4228 16.3943 22.1776 16.4959 21.9967 16.6768C21.8159 16.8576 21.7143 17.1029 21.7143 17.3586C21.7143 17.6144 21.8159 17.8596 21.9967 18.0405C22.1776 18.2213 22.4228 18.3229 22.6786 18.3229Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMedia);
export default __webpack_public_path__ + "static/media/menu-media.3a3e99e347466ac5cabb0d3e327aaf31.svg";
export { ForwardRef as ReactComponent };